var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"k-contract pt-4 px-5"},[(_vm.loading)?_c('v-icon',[_vm._v("fas fa-circle-notch fa-spin")]):_c('div',{domProps:{"innerHTML":_vm._s(_vm.currentContractHtml)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }